import { FC } from "react";
import { GitbookUnifiedProps } from "shared/ui/markdown/components/gitbook";

const HINT_CLASSNAMES = {
  info: "border-blue-400 bg-blue-50 text-blue-800",
  success: "border-green-400 bg-green-50 text-green-800",
  warning: "border-yellow-400 bg-yellow-50 text-yellow-800",
  danger: "border-red-400 bg-red-50 text-red-800",
  error: "border-red-400 bg-red-50 text-red-800",
};

const HINT_ICONS = {
  info: "ℹ️",
  success: "✅",
  warning: "⚠️",
  danger: "⚠️",
  error: "❌",
};

/**
 * Gitbook hint component that handles different variations of hints
 * (info, success, warning, danger, error)
 */
export const GitbookHintComponent: FC<GitbookUnifiedProps> = ({
  children,
  node,
}) => {
  //  style describes the hint variation
  const style = node?.properties?.style;

  const getStyleClasses = (style?: string, type?: string) => {
    const styleValue = style || type || "info";
    return HINT_CLASSNAMES[styleValue as keyof typeof HINT_CLASSNAMES];
  };

  const getIcon = (style: string) => {
    const styleValue = style || "info";
    return HINT_ICONS[styleValue as keyof typeof HINT_ICONS];
  };

  const icon = getIcon(style);
  const styleClasses = getStyleClasses(style);

  return (
    <div className={`my-8 rounded-lg border p-4 ${styleClasses}`}>
      <div className="flex items-start gap-2">
        <span className="flex-shrink-0 text-lg leading-none">{icon}</span>
        <div className="min-w-0 flex-1 [&>p]:m-0">{children}</div>
      </div>
    </div>
  );
};
